import React from "react";
import IntroText from "@/components/IntroText";
import {r} from "@/utils/responsive";

interface IntroContentProps extends React.HTMLAttributes<HTMLDivElement> {
}

const IntroContent: React.FC<IntroContentProps> = ({className, ...props}) => {
    return (
        <div
            {...props}
            style={{
                position: "absolute",
                inset: 0,
            }}
        >
            <div>
                <IntroText/>
            </div>
        </div>
    );
};

export default IntroContent;
